let OBSERVER = "IntersectionObserver" in window;
// let OBSERVER = false; // uncomment to test scroll fallback

export default class Observer {

	constructor(callback, options) {
		this.callback = callback;
		this.options = options;
		this.observables = new Map();
		if (!OBSERVER || options && options.scroll) this.enableScroll();
		else this.observer = new IntersectionObserver(this.observeScan.bind(this), options);
	}

	enableScroll () {
		this.listener = this.scrollScan.bind(this);
		setTimeout(() => {
			Z.on('AppResize', this.listener);
			Z.on('AppScroll', this.listener);
			this.scrollScan();
		}, 300);
	}

	observe (el) {
		this.observables.set(el, false);
		if (OBSERVER) this.observer.observe(el);
	}

	unobserve (el) {
		this.observables.delete(el);
		if (OBSERVER) this.observer.unobserve(el);
	}

	observeScan (entries) {
		let inViewArr = [];
		entries.forEach(entry => this.observables.set(entry.target, entry.isIntersecting));
		this.observables.forEach((value, key) => {
			if (value) inViewArr.push(key);
		});
		this.callback(entries, inViewArr);
	}

	scrollScan () {
		let entries = [], inViewArr = [], isIntersecting;
		this.observables.forEach((value, el) => {
			isIntersecting = Z.elementInViewport(el);
			this.observables.set(el, isIntersecting);
			entries.push({ target: el, isIntersecting });
			if (isIntersecting) inViewArr.push(el);
		});
		this.callback(entries, inViewArr);
	}

	disconnect () {
		if (this.observer) this.observer.disconnect();
		this.observables.clear();
	}

	destroy () {
		this.disconnect();
		Z.off('AppResize', this.listener);
		Z.off('AppScroll', this.listener);
	}

}
